import {CheckOutlined} from '@mui/icons-material';
import {MenuItem, Typography, useTheme} from '@mui/material';

type HeaderMenuItemProps = {
    isActiveElement: boolean;
    onClick: () => void;
    title: string | React.ReactNode;
};

export const HeaderMenuItem = ({isActiveElement, onClick, title}: HeaderMenuItemProps) => {
    const theme = useTheme();
    return (
        <MenuItem
            onClick={() => onClick()}
            sx={{
                display: 'flex',
                direction: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: '36px',
                minHeight: '36px',
                color: isActiveElement ? 'var(--mui-palette-primary-main)' : '',
                background: isActiveElement
                    ? 'linear-gradient(90deg, rgba(2, 86, 127, 0) 0%, rgba(3, 155, 229, 0.08) 4.38%, rgba(3, 155, 229, 0.08) 43%, rgba(2, 86, 127, 0) 100%)'
                    : '',
                [theme.breakpoints.down('sm')]: {paddingLeft: '8px'},
            }}
        >
            <Typography sx={{display: 'inline-flex', gap: '4px'}}>{title}</Typography>
            {isActiveElement && <CheckOutlined />}
        </MenuItem>
    );
};
